// extracted by css-extract-rspack-plugin
export default {"colorDot":"cevzL"};